<div class="min-vh-100 bg-light">
  <app-header [page]="'Wallets'"></app-header>

  <main class="container py-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="mb-0 fw-bold">Confirm Withdrawal</h4>
        <div class="text-muted small">Review your details before submission</div>
      </div>
    </div>

    <div class="card shadow-sm border-0 mb-3" *ngIf="payload">
      <div class="card-body">
        <div class="row g-3 mb-3">
          <div class="col-md-6">
            <div class="text-muted small">Amount</div>
            <div class="fw-semibold">
              {{ payload.amount | smartAmount:payload.config.currency.symbol }}
            </div>
          </div>

          <div class="col-md-6">
            <div class="text-muted small">Currency</div>
            <div class="fw-semibold">
              {{ payload.config.currency.code }}
            </div>
          </div>

          <div class="col-md-6">
            <div class="text-muted small">Payment Method</div>
            <div class="fw-semibold">
              {{ payload.paymentMethod || 'N/A' }}
            </div>
          </div>

          <div class="col-md-6">
            <div class="text-muted small">Jurisdiction</div>
            <div class="fw-semibold">
              {{ payload.config.jurisdictionCode }}
            </div>
          </div>
        </div>

        <div class="alert alert-light border" *ngIf="payload.quote">
          <div class="fw-bold mb-2">Fee Preview</div>

          <div class="row g-3">
            <div class="col-md-4">
              <div class="text-muted small">Recipient Receives</div>
              <div class="fw-semibold">
                {{ payload.quote.recipientGets | smartAmount:payload.config.currency.symbol }}
              </div>
            </div>

            <div class="col-md-4">
              <div class="text-muted small">Fee</div>
              <div class="fw-semibold">
                {{ payload.quote.fee | smartAmount:payload.config.currency.symbol }}
              </div>
            </div>

            <div class="col-md-4">
              <div class="text-muted small">Wallet Debit</div>
              <div class="fw-semibold">
                {{ payload.quote.totalDebit | smartAmount:payload.config.currency.symbol }}
              </div>
            </div>

            <div class="col-md-4">
              <div class="text-muted small">Method</div>
              <div class="fw-semibold">
                {{ payload.quote.paymentMethod || payload.paymentMethod || 'N/A' }}
              </div>
            </div>
          </div>
        </div>

        <div class="alert alert-info" *ngIf="payload.resolutionResult">
          <div class="fw-semibold mb-1">Resolved account</div>
          <div *ngFor="let item of resolutionEntries">
            <span class="text-muted">{{ pretty(item.key) }}:</span>
            <span class="fw-semibold ms-1">{{ item.value }}</span>
          </div>
        </div>

        <hr>

        <h6 class="fw-bold mb-3">Destination Details</h6>

        <div class="row g-3">
          <div class="col-md-6" *ngFor="let item of destinationEntries">
            <div class="text-muted small">{{ item.label }}</div>
            <div class="fw-semibold">{{ item.value }}</div>
          </div>
        </div>

        <!-- <div class="mt-3" *ngIf="payload.saveBeneficiary">
          <span class="badge text-bg-light border">
            Beneficiary will be saved
            <span *ngIf="payload.beneficiaryNickname">({{ payload.beneficiaryNickname }})</span>
          </span>
        </div> -->
      </div>
    </div>

    <div class="card shadow-sm border-0 mb-3" *ngIf="payload?.saveBeneficiary">
      <div class="card-body">
        <h6 class="fw-bold mb-2">Beneficiary</h6>
        <div class="row g-3">
          <div class="col-md-6">
            <div class="text-muted small">Save Beneficiary</div>
            <div class="fw-semibold">Yes</div>
          </div>

          <div class="col-md-6" *ngIf="payload?.beneficiaryNickname">
            <div class="text-muted small">Nickname</div>
            <div class="fw-semibold">{{ payload?.beneficiaryNickname }}</div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="alert alert-info small mb-3" *ngIf="requiresWithdrawalPin">
      <div class="fw-semibold mb-1">PIN authorization enabled</div>
      You will be asked for your six-digit account PIN when you commit this withdrawal.
    </div>

    <div class="alert alert-warning small mb-3" *ngIf="payload?.quote">
  By confirming, the recipient will receive
  <strong>
    {{ payload!.quote!.recipientGets | smartAmount:payload!.config!.currency!.symbol }}
  </strong>
  and your wallet will be debited
  <strong>
    {{ payload!.quote!.totalDebit | smartAmount:payload!.config!.currency!.symbol }}
  </strong>
  including fees.
</div>

<div class="d-flex justify-content-between align-items-center gap-2 mb-4">
  <button
    class="btn btn-outline-secondary px-4"
    type="button"
    (click)="back()"
    [disabled]="submitting">
    Back
  </button>

  <button
    class="btn btn-primary px-4"
    type="button"
    [disabled]="submitting || securityLoading"
    (click)="confirm()">
    <span *ngIf="submitting" class="spinner-border spinner-border-sm me-2"></span>
    {{ submitting ? 'Submitting...' : 'Confirm Withdrawal' }}
  </button>
</div>

    <app-footer></app-footer>
  </main>

  <app-account-pin-pad
    [modal]="true"
    [(visible)]="showWithdrawalPinModal"
    [(pin)]="accountPin"
    title="Authorize withdrawal"
    description="Enter your six-digit account PIN to commit this withdrawal."
    confirmLabel="Authorize Withdrawal"
    [loading]="submitting"
    [error]="withdrawalPinError"
    (pinSubmit)="authorizeWithdrawal($event)"
    (cancelled)="closeWithdrawalPinModal()">
  </app-account-pin-pad>
</div>